import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [currentSection, setCurrentSection] = useState('home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setScrolled(scrollPosition > 50);

      // Determine current section based on scroll position
      const sections = ['home', 'about', 'expertise', 'features', 'branches', 'partners', 'contact'];
      const sectionElements = sections.map(id => ({
        id,
        element: document.getElementById(id),
      }));

      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const { id, element } = sectionElements[i];
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100) {
            setCurrentSection(id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
      setMobileMenuOpen(false); // Close mobile menu on link click
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${currentSection} ${mobileMenuOpen ? 'mobile-menu-open' : ''}`}>
      <div className="navbar-container">
        <a href="#home" className="navbar-logo" onClick={(e) => handleSmoothScroll(e, 'home')}>
          <img src="/logo.png" alt="Tara Medicos logo" className="navbar-logo-icon" />
          <span className="navbar-logo-text">TARA MEDICOS PVT LTD.</span>
        </a>
        <button
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <a
              href="#home"
              className={`navbar-link ${currentSection === 'home' ? 'active' : ''}`}
              onClick={(e) => handleSmoothScroll(e, 'home')}
            >
              Home
            </a>
          </li>
          <li className="navbar-item">
            <a
              href="#about"
              className={`navbar-link ${currentSection === 'about' ? 'active' : ''}`}
              onClick={(e) => handleSmoothScroll(e, 'about')}
            >
              Our Journey
            </a>
          </li>
          <li className="navbar-item">
            <a
              href="#expertise"
              className={`navbar-link ${currentSection === 'expertise' ? 'active' : ''}`}
              onClick={(e) => handleSmoothScroll(e, 'expertise')}
            >
              What We Do
            </a>
          </li>
          <li className="navbar-item">
            <a
              href="#branches"
              className={`navbar-link ${currentSection === 'branches' ? 'active' : ''}`}
              onClick={(e) => handleSmoothScroll(e, 'branches')}
            >
              Branches
            </a>
          </li>
          <li className="navbar-item">
            <a
              href="#partners"
              className={`navbar-link ${currentSection === 'partners' ? 'active' : ''}`}
              onClick={(e) => handleSmoothScroll(e, 'partners')}
            >
              Our Principals
            </a>
          </li>
          <li className="navbar-item">
            <a
              href="#contact"
              className={`navbar-link ${currentSection === 'contact' ? 'active' : ''}`}
              onClick={(e) => handleSmoothScroll(e, 'contact')}
            >
              Contact
            </a>
          </li>
          <li className="navbar-item dropdown-container">
            <button className="navbar-link navbar-btn order-btn" aria-haspopup="true">
              Order / Login <span className="arrow-down">▼</span>
            </button>
            <div className="dropdown-menu">
              <a href="https://liveconnect.in/site/login" target="_blank" rel="noopener noreferrer" className="dropdown-item">
                Customer Login
              </a>
              <a href="https://online.taramed.in/login" target="_blank" rel="noopener noreferrer" className="dropdown-item">
                Representative Login
              </a>
           
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
